import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import {CabinetLayout} from "@/routes/CabinetLayout";
import {CabinetBenefitsPage} from "@/routes/CabinetBenefitsPage";
import {CabinetCancelReasonPage} from "@/routes/CabinetCancelReasonPage";
import {CabinetSubscriptionFreezePage} from "@/routes/CabinetSubscriptionFreezePage";
import {CabinetCancellationConfirmedPage} from "@/routes/CabinetCancellationConfirmedPage";
import {CabinetPauseConfirmedPage} from "@/routes/CabinetPauseConfirmedPage";
import {CabinetSubscriptionUnfreezePage} from "@/routes/CabinetSubscriptionUnfreezePage";
import {CabinetUnfreezeConfirmedPage} from "@/routes/CabinetUnfreezeConfirmedPage";
import {CabinetOperationHistoryPage} from "@/routes/CabinetOperationHistoryPage";
import {SubscribePage} from "@/routes/SubscribePage";

export function App() {
  return (
      <BrowserRouter>
      <Routes>
          <Route path="/subscribe" element={<SubscribePage/>}/>
          <Route path="/subscribe/" element={<SubscribePage/>}/>
          <Route path="/cabinet" element={<CabinetLayout/>}>
              <Route index element={<CabinetBenefitsPage/>}/>
              <Route path="subscription/cancel" element={<CabinetCancelReasonPage/>}/>
              <Route path="subscription/cancel/freeze" element={<CabinetSubscriptionFreezePage/>}/>
              <Route path="subscription/cancelled" element={<CabinetCancellationConfirmedPage/>}/>
              <Route path="subscription/paused" element={<CabinetPauseConfirmedPage/>}/>
              <Route path="subscription/unfreeze" element={<CabinetSubscriptionUnfreezePage/>}/>
              <Route path="subscription/unfrozen" element={<CabinetUnfreezeConfirmedPage/>}/>
              <Route path="history" element={<CabinetOperationHistoryPage/>}/>
              <Route path="*" element={<Navigate to="/cabinet" replace/>}/>
          </Route>
          <Route path="/cabinet/" element={<Navigate to="/cabinet" replace/>}/>
          <Route path="*" element={<Navigate to="/subscribe/" replace/>}/>
      </Routes>
    </BrowserRouter>
  );
}
